import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import { SITE_URL, OG_IMAGE } from "@/lib/site-data";
import { breadcrumbLd, webPageLd } from "@/lib/seo";

const title = "Satisfaction Guarantee | JTB Floors";
const description =
  "JTB Floors offers a 100% satisfaction guarantee on all labor. Water damage? We'll still fix the flooring. BBB accredited. Serving Barrington, IL.";

export const Route = createFileRoute("/warranty-discounts")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/warranty-discounts` },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/warranty-discounts` }],
    scripts: [breadcrumbLd("Warranty & Discounts", "/warranty-discounts"), webPageLd("WebPage", title, description, "/warranty-discounts")],
  }),
  component: About,
});
